import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return value;
    }

    // Remove all non-digit characters
    const cleaned = ('' + value).replace(/\D/g, '');

    // Check if the input is valid (10 or 11 digits)
    if (cleaned.length === 10) {
      // Format as (XXX) XXX-XXXX
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
    } else if (cleaned.length === 11 && cleaned[0] === '1') {
      // Format as 1 (XXX) XXX-XXXX
      const match = cleaned.match(/^1(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '1 (' + match[1] + ') ' + match[2] + '-' + match[3];
      }
    }

    // Return original value if it doesn't match expected formats
    return value;
  }

}
